import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const PopupSettingGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewPopupSetting === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

PopupSettingGuard.propTypes = {
  children: PropTypes.node,
};

export default PopupSettingGuard;
